// Core Base Tool Class - Generic blueprint for all tool implementations
// Completely generic - no workspace/app-type logic
// Subclasses create all functions

export class BaseTool {
  constructor() {
    this.toolSystem = null; // Set by ToolSystem.registerTool()
    // toolName is set by subclasses in their constructors
    this.toolName = null;
  }

  /**
   * Return a success result with data and message
   * @param {Object} data - Result data object
   * @param {string} message - Success message
   * @returns {Object} Success result object
   */
  returnSuccess(data, message) {
    return {
      success: true,
      data,
      message,
    };
  }

  /**
   * Return an error result with optional data and message
   * @param {Object} data - Optional error data object (can be empty {})
   * @param {string} message - Error message
   * @returns {Object} Error result object
   */
  returnError(data, message) {
    return {
      success: false,
      data,
      message,
    };
  }
}
